import { BellRing, BellOff } from "lucide-react";
import useKitchenChime from "../lib/useKitchenChime";

/**
 * Compact bar shown in the employee layout that plays a repeating chime
 * whenever a new production order lands in the kitchen queue. The bar itself
 * shows a Snooze / Resume button so the kitchen staff can silence it after
 * acknowledging the work.
 */
export default function KitchenAlertBar() {
  const { hasPending, snoozed, snooze, resume, pendingCount } = useKitchenChime(true);
  if (!hasPending) return null;
  return (
    <div
      data-testid="kitchen-alert-bar"
      className={`fixed bottom-6 right-6 z-[65] shadow-[var(--shadow-floating)] rounded-full px-4 py-2.5 flex items-center gap-3 border ${
        snoozed
          ? "bg-card border-border text-muted-foreground"
          : "bg-foreground text-background border-foreground"
      }`}
    >
      {snoozed ? <BellOff className="h-4 w-4" /> : <BellRing className="h-4 w-4 animate-pulse" />}
      <span className="text-xs font-medium">
        {snoozed
          ? `Chime snoozed · ${pendingCount} pending`
          : `${pendingCount} order${pendingCount > 1 ? "s" : ""} to pull`}
      </span>
      {snoozed ? (
        <button
          onClick={resume}
          data-testid="kitchen-alert-resume"
          className="text-[11px] font-medium underline underline-offset-2 hover:no-underline"
        >
          Resume
        </button>
      ) : (
        <button
          onClick={snooze}
          data-testid="kitchen-alert-snooze"
          className="text-[11px] font-medium bg-background/10 hover:bg-background/20 rounded-full px-3 py-1"
        >
          Snooze
        </button>
      )}
    </div>
  );
}
